import instance from "./auth";

export const getAllPay = async (params) => {
    const {data} = await instance.get("/earning/pay", {
        params,
    });
    return data;
}

export const getAllPaid = async (params) => {
    const {data} = await instance.get("/earning/paid", {
        params,
    });
    return data;
}

export const getAllCancel = async (params) => {
    const {data} = await instance.get("/earning/cancel", {
        params,
    });
    return data;
}

export const getAllOutstanding = async (params) => {
    const {data} = await instance.get("/earning/outstanding", {params});
    return data;
}

export const add = async (data) => {
    const {data: result} = await instance.post("/earning", data);
    return result;
}

export const updateById = async (id, data) => {
    const {data: result} = await instance.put(`/earning/${id}`, data);
    return result;
}
